export const COMMERCE_PROBLEMS = Object.freeze({
  CANCEL_BEFORE_SHIPPING: "cancel_before_shipping",
  RETURN_PRODUCT: "return_product",
  DEFECTIVE_OR_WRONG_PRODUCT: "defective_or_wrong_product",
  REFUND_NOT_RECEIVED: "refund_not_received",
  RETURN_REJECTED: "return_rejected",
  NOT_DELIVERED: "not_delivered",
  DUPLICATE_CHARGE: "duplicate_charge",
  UNREACHABLE: "unreachable",
  OTHER: "other",
});

export const COMMERCE_PROBLEM_OPTIONS = Object.freeze([
  { value: COMMERCE_PROBLEMS.CANCEL_BEFORE_SHIPPING, label: "Siparişi teslim edilmeden iptal etmek istiyorum" },
  { value: COMMERCE_PROBLEMS.RETURN_PRODUCT, label: "Ürünü iade etmek istiyorum" },
  { value: COMMERCE_PROBLEMS.DEFECTIVE_OR_WRONG_PRODUCT, label: "Ürün bozuk, eksik veya yanlış geldi" },
  { value: COMMERCE_PROBLEMS.REFUND_NOT_RECEIVED, label: "Ürünü gönderdim ama param gelmedi" },
  { value: COMMERCE_PROBLEMS.RETURN_REJECTED, label: "İade talebim reddedildi" },
  { value: COMMERCE_PROBLEMS.NOT_DELIVERED, label: "Sipariş hiç teslim edilmedi" },
  { value: COMMERCE_PROBLEMS.DUPLICATE_CHARGE, label: "Aynı ödeme iki kez alındı" },
  { value: COMMERCE_PROBLEMS.UNREACHABLE, label: "Satıcıya veya platforma ulaşamıyorum" },
  { value: COMMERCE_PROBLEMS.OTHER, label: "Başka bir sorun" },
]);

export const PURCHASE_ACCOUNT_MODES = Object.freeze({
  MEMBER: "member",
  GUEST: "guest",
  UNKNOWN: "unknown",
});

export const PURCHASE_ACCOUNT_MODE_OPTIONS = Object.freeze([
  { value: PURCHASE_ACCOUNT_MODES.MEMBER, label: "Evet, hesabımla giriş yaparak verdim" },
  { value: PURCHASE_ACCOUNT_MODES.GUEST, label: "Hayır, üye olmadan sipariş verdim" },
  { value: PURCHASE_ACCOUNT_MODES.UNKNOWN, label: "Emin değilim" },
]);

export const COMMERCE_DEFECTIVE_OUTCOMES = Object.freeze([
  { id: "repair", label: "Ücretsiz onarım", sentence: "Ürünün ücretsiz onarılmasını istiyorum." },
  { id: "replacement", label: "Ürün değişimi", sentence: "Ürünün ayıpsız bir ürünle değiştirilmesini istiyorum." },
  { id: "completion", label: "Eksik ürün/parça tamamlama", sentence: "Eksik ürün veya parçanın tamamlanmasını istiyorum." },
  { id: "discount", label: "Ücret indirimi", sentence: "Sorunla orantılı ücret indirimi yapılmasını istiyorum." },
  { id: "refund", label: "Para iadesi", sentence: "Ödediğim bedelin iade edilmesini istiyorum." },
  { id: "assessment", label: "Önce satıcı/platform değerlendirsin", sentence: "Durumun satıcı veya platform tarafından incelenerek uygun çözümün yazılı bildirilmesini istiyorum." },
]);

export const COMMERCE_INFO_FIELDS = Object.freeze([
  ["transactionNumber", "Sipariş numarası", ""],
  ["orderDate", "Sipariş tarihi", ""],
  ["productName", "Ürün adı", ""],
  ["sellerName", "Satıcı / mağaza adı", ""],
  ["paidAmount", "Ödenen tutar", ""],
  ["refundAmount", "Talep edilen iade tutarı", ""],
  ["refundRequestDate", "İade talep tarihi", ""],
  ["returnShippingDate", "Ürünün kargoya verildiği tarih", ""],
  ["returnShippingCode", "İade kargo kodu", ""],
  ["trackingNumber", "Kargo takip numarası", ""],
  ["returnDeliveredDate", "İade ürününün teslim tarihi", ""],
  ["statedRefundDate", "İade edildiği söylenen tarih", ""],
  ["paymentMethod", "Ödeme yöntemi", "Kart numarasının tamamını yazmayın"],
  ["platformResponse", "Platformun veya satıcının verdiği cevap", ""],
]);

export function isEcommerceInstitutionContext(context) {
  return context?.category === "ecommerce";
}

export function getCommerceProblemOption(value) {
  return COMMERCE_PROBLEM_OPTIONS.find((option) => option.value === value) || null;
}

export function buildCommerceDescription({ commerceProblem, desiredOutcome, info = {} }) {
  const parts = [];
  const problem = getCommerceProblemOption(commerceProblem);
  if (problem) parts.push(`E-ticaret sorunu: ${problem.label}.`);
  if (desiredOutcome?.sentence) parts.push(desiredOutcome.sentence);
  for (const [id, label] of COMMERCE_INFO_FIELDS) {
    const value = String(info[id] || "").trim();
    if (value) parts.push(`${label}: ${value}.`);
  }
  return parts.join(" ");
}
